module.exports = __webpack_public_path__ + "img/youtube.a9e972c.png";